import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const getAllEmployeeDetails = async (org_id: any) => {
  const path = `/orgs/${org_id}/employee`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
